import { gql } from '@apollo/client';

export const DELETE_JOB_EXTERNAL_STAKEHOLDER_MUTATION = gql`
  mutation deleteJobExternalStakeholder($id: Int!) {
    deleteJobExternalStakeholder(id: $id) {
      status
      error
    }
  }
`;

export const CREATE_JOB_EXTERNAL_STAKEHOLDER_MUTATION = gql`
  mutation createJobExternalStakeholder(
    $contactIds: [Int!]!,
    $jobId: Int!,
    $serviceType: ExternalStakeholderServiceTypeEnum!
  ) {
    createJobExternalStakeholder(contactIds: $contactIds, jobId: $jobId, serviceType: $serviceType) {
      success
    }
  }
`;

export const CREATE_JOB_COMPANY_CONTACT_MUTATION = gql`
  mutation createJobCompanyContact(
    $companyId: Int!
    $firstName: String!
    $lastName: String!
    $email: String!
  ) {
    createJobCompanyContact(
      companyId: $companyId
      firstName: $firstName
      lastName: $lastName
      email: $email
    ) {
      success
    }
  }
`;

export const CREATE_JOB_STAKEHOLDER_CONTACT_MUTATION = gql`
  mutation createJobStakeholderContact(
    $jobId: Int!, 
    $companyId: Int!, 
    $firstName: String!, 
    $lastName: String!, 
    $email: String!,
    $serviceType: ExternalStakeholderServiceTypeEnum!
  ) {
    createJobStakeholderContact(
      jobId: $jobId
      companyId: $companyId
      firstName: $firstName
      lastName: $lastName
      email: $email
      serviceType: $serviceType
    ) {
      success
      error
    }
  }
`;